import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PageSection from '~components/page-section';
import { StyledItemsWrapper, StyledIconWrapper } from './styled';
import { Flex, Icon, Paragraph } from '@phishtool/ui';
const iconHeight = 72;
const iconMap = {
    ingestion: {
        name: 'email-ingestion',
        width: 82,
    },
    console: {
        name: 'forensic-console',
        width: 63,
    },
    parsing: {
        name: 'parsing',
        width: 83,
    },
    reporting: {
        name: 'reporting',
        width: 68,
    },
};
const HowDoesPhishToolWorkItem = ({ type, title, description }) => {
    const icon = iconMap[type];
    return (_jsxs(Flex, { align: "center", gap: "x3", children: [_jsx(StyledIconWrapper, { children: _jsx(Icon, { name: icon.name, size: { width: icon.width, height: iconHeight }, color: "silverPearl" }) }), _jsxs(Flex, { direction: "column", flex: 1, children: [_jsx(Paragraph, { fontWeight: "bold", spacer: "x0", children: title }), _jsx(Paragraph, { spacer: "x0", children: description })] })] }));
};
const HowDoesPhishToolWork = ({ title, intro, items }) => (_jsx(PageSection, { id: "how", headerSpacer: ['x3', null, 'x9'], title: title, intro: intro, children: _jsx(Flex, { justify: "center", children: _jsx(StyledItemsWrapper, { children: items.map((item) => (_jsx(HowDoesPhishToolWorkItem, Object.assign({}, item), item.type))) }) }) }));
export default HowDoesPhishToolWork;
